export interface DialogOptions {
  title?: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
}

/** Opens a confirm-style dialog and resolves with the user's choice. */
export function openDialog(options: DialogOptions): Promise<boolean> {
  return new Promise((resolve) => {
    const overlay = document.createElement('div')
    overlay.className = 'sn-dialog-overlay'

    const dialog = document.createElement('div')
    dialog.className = 'sn-dialog'
    dialog.setAttribute('role', 'alertdialog')
    dialog.setAttribute('aria-modal', 'true')

    if (options.title) {
      const heading = document.createElement('h2')
      heading.className = 'sn-dialog__title'
      heading.textContent = options.title
      dialog.appendChild(heading)
    }

    const message = document.createElement('p')
    message.className = 'sn-dialog__message'
    message.textContent = options.message
    dialog.appendChild(message)

    const actions = document.createElement('div')
    actions.className = 'sn-dialog__actions'

    const cancelBtn = document.createElement('button')
    cancelBtn.className = 'sn-dialog__button sn-dialog__button--secondary'
    cancelBtn.textContent = options.cancelLabel ?? 'Cancel'

    const confirmBtn = document.createElement('button')
    confirmBtn.className = 'sn-dialog__button sn-dialog__button--primary'
    confirmBtn.textContent = options.confirmLabel ?? 'OK'

    actions.append(cancelBtn, confirmBtn)
    dialog.appendChild(actions)
    overlay.appendChild(dialog)
    document.body.appendChild(overlay)

    function settle(result: boolean): void {
      overlay.remove()
      resolve(result)
    }

    cancelBtn.addEventListener('click', () => settle(false))
    confirmBtn.addEventListener('click', () => settle(true))
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay)
        settle(false)
    })

    confirmBtn.focus()
  })
}
